import { differenceInCalendarDays, parseISO } from "date-fns";
import { isAuthenticated } from "./identityUtils";
import { getSubscriptionDetails } from "./getSubscriptionDetails";

export const PREMIER_NON_MEMBER = "premier non member";
export const PREMIER_ACTIVE = "premier active";
export const PREMIER_ACTIVE_RECURRING = "premier active - recurring";
export const PREMIER_EXPIRED = "premier expired";
export const PREMIER_EXPIRED_RECURRING = "premier expired - recurring";
export const PREMIER_EXPIRING = "premier expiring";
export const PREMIER_TERM_ENDING_RECURRING = "premier term ending - recurring";
export const PREMIER_INITIALLY_EXPIRED = "premier initially expired";
export const PREMIER_INITIALLY_EXPIRED_RECURRING =
  "premier initially expired - recurring";

// eslint-disable-next-line complexity
export const getPremierAnalytics = async () => {
  let latestPremierSubscription = null;
  const authenticated = await isAuthenticated();
  if (authenticated) {
    const subscriptions = await getSubscriptionDetails();
    if (subscriptions?.length > 0) {
      let store = window.asos.webContext && window.asos.webContext.getStoreId();
      store === "COM" ? (store = "GB") : store;
      latestPremierSubscription = subscriptions.find(
        (subscription) => subscription.country === store
      );
    }
  }

  if (
    latestPremierSubscription === null ||
    latestPremierSubscription.status === "PurchaseProcessing" ||
    latestPremierSubscription.status === "Cancelled"
  ) {
    return PREMIER_NON_MEMBER;
  }

  const now = new Date();
  let daysDifference;

  if (latestPremierSubscription?.status === "Active") {
    daysDifference = differenceInCalendarDays(
      parseISO(latestPremierSubscription.endDate),
      now
    );
  }

  if (latestPremierSubscription?.status === "Expired") {
    daysDifference = differenceInCalendarDays(
      now,
      parseISO(latestPremierSubscription.endDate)
    );
  }

  // Conditions have been written in order of specificity in order to cover all scenarios
  if (
    latestPremierSubscription.status === "Active" &&
    daysDifference <= 30 &&
    latestPremierSubscription.instructionType === "OneOff"
  ) {
    return PREMIER_EXPIRING;
  }

  if (
    latestPremierSubscription.status == "Active" &&
    daysDifference <= 30 &&
    latestPremierSubscription.instructionType === "Recurring"
  ) {
    return PREMIER_TERM_ENDING_RECURRING;
  }

  if (
    latestPremierSubscription.status == "Expired" &&
    daysDifference <= 30 &&
    latestPremierSubscription.instructionType === "OneOff"
  ) {
    return PREMIER_INITIALLY_EXPIRED;
  }

  if (
    latestPremierSubscription.status == "Expired" &&
    daysDifference <= 30 &&
    latestPremierSubscription.instructionType === "Recurring"
  ) {
    return PREMIER_INITIALLY_EXPIRED_RECURRING;
  }

  if (
    latestPremierSubscription.status === "Active" &&
    latestPremierSubscription.instructionType === "OneOff"
  ) {
    return PREMIER_ACTIVE;
  }

  if (
    latestPremierSubscription.status === "Active" &&
    latestPremierSubscription.instructionType === "Recurring"
  ) {
    return PREMIER_ACTIVE_RECURRING;
  }

  if (
    latestPremierSubscription.status === "Expired" &&
    latestPremierSubscription.instructionType === "OneOff"
  ) {
    return PREMIER_EXPIRED;
  }

  if (
    latestPremierSubscription.status === "Expired" &&
    latestPremierSubscription.instructionType === "Recurring"
  ) {
    return PREMIER_EXPIRED_RECURRING;
  }
};
